import { useEffect, useRef, useState } from 'react';

const highlights = [
  { icon: 'ri-shield-check-line', text: 'Especialistas em crimes digitais e fraudes bancárias' },
  { icon: 'ri-time-line', text: 'Atendimento rápido e estratégico para casos urgentes' },
  { icon: 'ri-focus-3-line', text: 'Atuação 100% focada em resultados concretos' },
  { icon: 'ri-lock-2-line', text: 'Absoluto sigilo e confidencialidade no seu caso' },
];

export default function About() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="sobre" className="py-28 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image column */}
          <div
            className="relative pb-8"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateX(0)' : 'translateX(-40px)',
              transition: 'all 0.7s cubic-bezier(0.4,0,0.2,1)',
            }}
          >
            <div
              className="relative rounded-2xl overflow-hidden"
              style={{ background: '#123E73', padding: '12px', boxShadow: '0 24px 64px rgba(11,47,91,0.18)' }}
            >
              <div
                className="rounded-xl overflow-hidden"
                style={{ border: '3px solid #C9A24A' }}
              >
                <img
                  src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/f051a5e7bb99b6904d15b12a63ad24e2.png"
                  alt="LC Advogados – Escritório especializado em crimes digitais em Franca SP"
                  className="w-full h-auto object-cover object-top"
                  style={{ maxHeight: '640px' }}
                />
              </div>
            </div>

            {/* Decorative badge – outside overflow-hidden, centered on bottom border */}
            <div
              className="absolute rounded-2xl flex flex-col items-center justify-center"
              style={{
                background: '#0B2F5B',
                boxShadow: '0 12px 32px rgba(11,47,91,0.35)',
                padding: '14px 28px',
                bottom: '16px',
                right: '24px',
                transform: 'translateY(50%)',
                minWidth: '160px',
                whiteSpace: 'nowrap',
              }}
            >
              <div className="font-serif font-bold text-2xl text-center leading-none" style={{ color: '#C9A24A' }}>+500</div>
              <div className="text-white/80 text-xs mt-1 leading-tight text-center whitespace-nowrap">casos resolvidos</div>
            </div>

            {/* Diagonal accent line */}
            <div
              className="absolute top-6 -right-3 w-6 h-24 rounded-full opacity-60"
              style={{ background: 'linear-gradient(to bottom, #C9A24A, transparent)' }}
            />
          </div>

          {/* Content column */}
          <div
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateX(0)' : 'translateX(40px)',
              transition: 'all 0.7s cubic-bezier(0.4,0,0.2,1) 0.15s',
            }}
          >
            <span
              className="text-xs font-bold tracking-widest uppercase mb-4 inline-block"
              style={{ color: '#C9A24A' }}
            >
              Sobre o Escritório
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold leading-tight mb-6" style={{ color: '#0B2F5B' }}>
              Advocacia <span style={{ color: '#C9A24A' }}>especializada</span> em fraudes digitais
            </h2>
            <p className="text-lg leading-relaxed mb-8" style={{ color: '#1A1A1A', opacity: 0.75 }}>
              O <strong>LC Advogados</strong> nasceu com um propósito claro: defender vítimas de golpes bancários e fraudes digitais em Franca e em todo o Brasil. Combinamos expertise jurídica, agilidade e profundo conhecimento em crimes digitais para entregar resultados reais.
            </p>
            <p className="text-base leading-relaxed mb-10" style={{ color: '#1A1A1A', opacity: 0.65 }}>
              Nosso time atua de forma estratégica e personalizada, entendendo que cada caso é único. Estamos ao seu lado desde o primeiro contato até a resolução completa da situação, com total sigilo e dedicação.
            </p>

            <ul className="space-y-4">
              {highlights.map((item, i) => (
                <li
                  key={i}
                  className="flex items-center gap-4"
                  style={{
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateX(0)' : 'translateX(20px)',
                    transition: `all 0.5s cubic-bezier(0.4,0,0.2,1) ${0.3 + i * 0.1}s`,
                  }}
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-full shrink-0"
                    style={{ background: 'linear-gradient(135deg,#C9A24A,#E1C67A)' }}
                  >
                    <i className={`${item.icon} text-base`} style={{ color: '#0B2F5B' }} />
                  </div>
                  <span className="text-sm font-medium" style={{ color: '#1A1A1A' }}>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
